export const tyLightColors = {
  "--font-family":
    "system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji, BlinkMacSystemFont, Helvetica Neue, Arial, PingFang SC, PingFang TC, PingFang HK, Microsoft Yahei, Microsoft JhengHei;",
  "--Fill_Background_Light": "#fff",
  "--Fill_Background": "#FAFAFA",
  "--Fill_Brand_Primary": "#1366EC",
  "--Text_White": "#fff",
  "--Text_Primary": "#181818",
  "--Text_Secondary": "#575757",
  "--Text_Caption": "#575757",
  "--Text_Disabled": "#999999",
  "--Text_Danger": "#D6260B",
  "--Text_Brand_Primary": "#1366EC",
  "--Text_Brand_Light": "#575757",
  "--Text_Black": "#181818",
  "--Fill_Tertiary": "#FAFAFA",
  "--Fill_Secondary": "#F4F4F4",
  "--Fill_Primary": "#F4F4F4",
  "--Fill_Disabled": "#E9E9E9",
  "--Fill_White": "#fff",
  "--Fill_Brand_Light": "#fff",
  "--Fill_Heavy": "#F4F4F4",
  "--Fill_Black": "#000",
  "--Fill_Brand_Background": "#E6EEFC",
  "--Fill_Brand_Tertiary": "#E6EEFC",
  "--Fill_Brand_Secondary": "#3080FF",
  "--Fill_Brand_Inverse": "#1366EC",
  "--Fill_Transparent_Primary": "#000",
  "--Fill_Transparent_Light": "#FAFAFA",
  "--Line_Light": "#E9E9E9",
  "--Line_Secondary": "#E9E9E9",
  "--Line_Primary": "#E9E9E9",
  "--Line_Heavy": "#D8D8D8",
  "--Line_Brand_Primary": "#1366EC",
  "--Danger": "#D6260B",
  "--Danger_Background": "#FFE9E5",
  "--Danger_Default": "#D6260B",
  "--Danger_Clicked": "#D6260B",
  "--Success": "#038024",
  "--Success_Background": "#D8F3E0",
  "--Success_Default": "#038024",
  "--Success_Clicked": "#038024",
  "--Caution": "#FCEBCA",
  "--Caution_Background": "#FFAC0A",
  "--Caution_Default": "#FFAC0A",
  "--Caution_Clicked": "#FFAC0A",
  "--Warning": "#FCEBCA",
  "--Warning_Background": "#FFAC0A",
  "--Warning_Default": "#FFAC0A",
  "--Warning_Clicked": "#FFAC0A",
  "--Processing": "#1366EC",
  "--Processing_Background": "#E6EEFC",
  "--Processing_Disabled": "#3080FF",
  "--Processing_Default": "#1366EC",
  "--Processing_Clicked": "#1366EC",
  "--Link": "#1366EC",
  "--Link_Background": "#EEEBFC",
  "--Link_Disabled": "#856EFA",
  "--Link_Default": "#1366EC",
  "--Link_Clicked": "#1366EC",
  "--Pending": "#717171",
  "--Pending_Background": "#F4F4F4",
  "--Pending_Disabled": "#E9E9E9",
  "--Pending_Default": "#717171",
  "--Pending_Clicked": "#717171",
  "--Gradient_Primary": "#FAFAFA",
  "--Gradient_Light": "#FAFAFA",
  "--Gradient_Heavy": "#FAFAFA",
  "--Gradient_Radial": "#FAFAFA",
  "--Decoration_Orange": "#FF6A00",
  "--Decoration_Green": "#038024",
  "--Decoration_Blue": "#1366EC",
  "--Decoration_Purple": "#6D54EB",
  "--Decoration_Dark_Purple": "#6D54EB",
  "--Decoration_Pink_Purple": "#6D54EB",
  "--Mask_Laptop": "rgba(0, 0, 0, 0.45)",
  "--Mask_Primary": "rgba(0, 0, 0, 0.45)",
  "--Mask_Secondary": "rgba(0, 0, 0, 0.45)",
  "--skeleton-bg": "rgba(0, 0, 0, 0.45)",
  "--Puppet_Input_Box_Shadow":
    "0px 12px 24px -16px rgba(54, 54, 73, 0.04),0px 12px 40px 0px rgba(51, 51, 71, 0.08),0px 0px 1px 0px rgba(44, 44, 54, 0.02)",
  "--Border_Radius_XS": "2px",
  "--Border_Radius_SM": "4px",
  "--Border_Radius": "0px",
  "--Border_Radius_LG": "0px",
  "--Border_Radius_XL": "0px",
  "--Line_Brand_Light": "#c3d7fa",
  "--Line_Brand_Secondary": "#c3d7fa",
  "--Danger_Disabled": "#ffccc4",
  "--Success_Disabled": "#a2e8b6",
  "--Caution_Disabled": "#ffd17a",
  "--Warning_Disabled": "#ffd17a",
  "--Decoration_Pink ": "#6d54eb",
};
